
//公共库
import { Component, Vue } from "vue-property-decorator";

//本地引入
import DTCls from "@/utils/datetime";
import { saveAs } from "@/api/request/base";
import Pagination from "@/comp/Pagination/index.vue";
import { customerCommentType, customerCommentList, customerCommentEdit, customerCommentExpprt } from "@/api/request/customer";

//组件
@Component({
  name: "CustomerComment",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = []; //数据
  private total: number = 0; //总数
  private typeList: any[] = []; //类型列表
  private avg_rating: number = 0; //总平均分
  private total_user: number = 0; //总评分人数
  private total_rating: number = 0; //总评分数
  private listLoading: boolean = true; //列表加载

  //请求数据
  private listQuery: any = {
    //页码
    page: 1,
    page_size: 20,

    //临时数据
    time: [], //时间
    user_id_str: "", //用户ID
    customer_id_str: "", //客服ID

    //请求数据
    type: "", //类型
    rating: 0, //评分
    status: -1, //状态
    user_id: 0, //用户ID
    customer_id: 0, //客服ID
    start_time: "", //开始时间
    end_time: "", //结束时间
  };

  //评分列表
  private ratingList: any[] = [
    { rating: 0, name: "全部评分" },
    { rating: 1, name: "1星" },
    { rating: 2, name: "2星" },
    { rating: 3, name: "3星" },
    { rating: 4, name: "4星" },
    { rating: 5, name: "5星" },
  ];

  //状态列表
  private statusList: any[] = [
    { status: -1, name: "全部状态" },
    { status: 0, name: "未解决" },
    { status: 1, name: "已解决" },
  ];

  //时间选择器参数
  get pickerOptions(): any {
    return {
      shortcuts: [
        {
          text: "今日",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getTodayStartTime()), new Date(DTCls.getTodayEndTime())]);
          },
        },
        {
          text: "昨日",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getYesterdayStartTime()), new Date(DTCls.getYesterdayEndTime())]);
          },
        },
        {
          text: "本周",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getCurWeekStartTime()), new Date(DTCls.getTodayEndTime())]);
          },
        },
        {
          text: "上周",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getLastWeekStartTime()), new Date(DTCls.getLastWeekEdnTime())]);
          },
        },
        {
          text: "本月",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getCurMonthStartTime()), new Date(DTCls.getTodayEndTime())]);
          },
        },
        {
          text: "上月",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getLastMonthStartTime()), new Date(DTCls.getLastMonthEndTime())]);
          },
        },
        {
          text: "最近一周",
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: "最近一个月",
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: "最近三个月",
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: "全部",
          onClick(picker: any) {
            picker.$emit("pick", []);
          },
        },
      ],
      disabledDate(time: Date) {
        return time.getTime() > Date.now();
      },
    };
  }

  //创建调用
  async created() {
    //获取列表
    await this.getTypeList();

    //获取列表
    this.getList();
  }

  //获取数据
  private async getList() {
    //显示等待
    this.listLoading = true;

    //数据赋值
    if (this.listQuery.time && this.listQuery.time.length == 2) {
      this.listQuery.end_time = `${this.listQuery.time[1]} 23:59:59`;
      this.listQuery.start_time = `${this.listQuery.time[0]} 00:00:00`;
    } else {
      this.listQuery.end_time = "";
      this.listQuery.start_time = "";
    }
    this.listQuery.user_id = Number(this.listQuery.user_id_str);
    this.listQuery.customer_id = Number(this.listQuery.customer_id_str);

    //获取数据
    const { data } = await customerCommentList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;
    this.avg_rating = data.avg_rating; //总平均分
    this.total_user = data.total_user; //总评分人数
    this.total_rating = data.total_rating; //总评分数

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //获取列表
  private async getTypeList() {
    //显示等待
    this.listLoading = true;

    //获取数据
    const customerCommentTypeData: any = await customerCommentType({});

    //数据赋值
    this.typeList = customerCommentTypeData.data;
    this.typeList.unshift({ name: "全部类型", code: "" });
  }

  //处理查询
  private handleSearch(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取数据
    this.getList();
  }

  //导出处理
  private async exportHandler() {
    //显示等待
    this.listLoading = true;

    //数据赋值
    if (this.listQuery.time && this.listQuery.time.length == 2) {
      this.listQuery.end_time = `${this.listQuery.time[1]} 23:59:59`;
      this.listQuery.start_time = `${this.listQuery.time[0]} 00:00:00`;
    } else {
      this.listQuery.end_time = "";
      this.listQuery.start_time = "";
    }
    this.listQuery.user_id = Number(this.listQuery.user_id_str);
    this.listQuery.customer_id = Number(this.listQuery.customer_id_str);

    //获取数据
    const { data } = await customerCommentExpprt(this.listQuery);

    //保存数据
    saveAs(data, "客服评价列表");

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //处理编辑
  private handleEdit(row: any): void {
    //数据赋值
    this.addForm = {
      //请求数据
      id: row.id, // 客服ID
      opt_type: row.opt_type, //类型
      opt_remark: row.opt_remark, //备注
    };

    //显示界面
    this.dialogVisible = true;
  }

  //返回类型
  private getTypeName(type: string): string {
    //返回数据
    for (var i: number = 0; i < this.typeList.length; i++) {
      if (type == this.typeList[i].code) {
        return this.typeList[i].name;
      }
    }
    return "";
  }

  //---------------------------- 编辑/创建客服 ----------------------------
  //定义变量
  private dialogVisible: boolean = false; //是否显示
  private dialogLoading: boolean = false; //对话框等待

  //操作状态列表
  private optTypeList: any[] = [
    { type: 0, name: "无" },
    { type: 1, name: "移除恶评" },
  ];

  //表单数据
  private addForm: any = {
    //请求数据
    id: 0, //ID
    opt_type: 0, //类型
    opt_remark: "", //备注
  };

  //处理更新
  private async updateData() {
    //保存数据
    await customerCommentEdit(this.addForm);

    //显示提示
    this.$notify({ title: "成功", message: "更新成功", type: "success", duration: 2000 });

    //隐藏界面
    this.dialogVisible = false;

    //重新获取数据
    this.getList();
  }
}
